import React from 'react';
import '../../styles/animations.css';

// Animated Input Component
export const AnimatedInput = ({ 
  type, 
  id, 
  name, 
  className, 
  placeholder, 
  value, 
  onChange, 
  autoComplete,
  disabled,
  label,
  error
}) => {
  return (
    <div className="animated-form-group">
      {label && <label htmlFor={id} className="form-label">{label}</label>}
      <input
        type={type}
        id={id}
        name={name}
        className={`form-input form-input-animated ${className || ''}`}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        disabled={disabled}
      />
      {error && <div className="form-error error-shake">{error}</div>}
    </div>
  );
};

// Animated Button Component
export const AnimatedButton = ({ 
  type, 
  className, 
  onClick, 
  disabled, 
  children,
  isLoading
}) => {
  return (
    <button
      type={type || 'button'}
      className={`btn-animated ${className || ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {isLoading ? (
        <span className="btn-loading-content">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" opacity="0.25"></circle>
            <path d="M12 2a10 10 0 0 1 10 10" opacity="1"></path>
          </svg>
          <span>Loading...</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
};

// Animated Social Button Component
export const AnimatedSocialButton = ({ 
  icon, 
  ariaLabel, 
  onClick 
}) => {
  return (
    <button 
      type="button" 
      className="social-btn social-btn-animated" 
      aria-label={ariaLabel}
      onClick={onClick}
    >
      {icon}
    </button>
  );
};

// Animated Checkbox Component
export const AnimatedCheckbox = ({ 
  id, 
  name, 
  checked, 
  onChange, 
  label,
  error
}) => {
  return (
    <div className="form-check animated-form-group">
      <input
        type="checkbox"
        id={id}
        name={name}
        className="form-check-input"
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={id} className="form-check-label">
        {label}
      </label>
      {error && <div className="form-error error-shake">{error}</div>}
    </div>
  );
};

// Animated Success Message Component
export const AnimatedSuccess = ({ title, message, actionButton }) => {
  return (
    <div className="text-center animated-form-group">
      <div className="success-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" className="success-checkmark"></path>
          <polyline points="22 4 12 14.01 9 11.01" className="success-checkmark"></polyline>
        </svg>
      </div>
      <h2 className="success-title">{title}</h2>
      <p className="success-message">{message}</p>
      {actionButton}
    </div>
  );
};

// Animated Divider Component
export const AnimatedDivider = ({ text }) => {
  return (
    <div className="divider animated-form-group">
      {text}
    </div>
  );
};

// Animated Form Footer Component
export const AnimatedFormFooter = ({ children }) => {
  return (
    <div className="auth-footer animated-form-group">
      {children}
    </div>
  );
};

// Password Strength Indicator Component
export const PasswordStrengthIndicator = ({ strength }) => {
  return (
    <div className="password-strength mt-2 animated-form-group" style={{marginLeft: '45%', marginTop:'1rem'}}>
      <div className={`strength-bar ${strength >= 1 ? 'active' : ''} ${strength >= 3 ? 'medium' : ''} ${strength >= 4 ? 'strong' : ''}`}></div>
      <div className={`strength-bar ${strength >= 2 ? 'active' : ''} ${strength >= 3 ? 'medium' : ''} ${strength >= 4 ? 'strong' : ''}`}></div>
      <div className={`strength-bar ${strength >= 3 ? 'active medium' : ''} ${strength >= 4 ? 'strong' : ''}`}></div>
      <div className={`strength-bar ${strength >= 4 ? 'active strong' : ''}`}></div>
      <div className={`strength-bar ${strength >= 5 ? 'active strong' : ''}`}></div>
    </div>
  );
};